import React, { useState } from "react";
import CommonGrid from '../../../Components/common/CommonGrid'
import Dropdown from 'react-bootstrap/Dropdown';
import Trash from "../../../assets/images/trash.png";
import Info from "../../../assets/images/info.png";
import RedCross from "../../../assets/images/close.png";
import edit from "../../../assets/images/edit.png";
import trash from "../../../assets/images/trash.png";
import view from "../../../assets/images/view.png";
import user from "../../../assets/images/superadmin/user_view.png";
import switc from "../../../assets/images/superadmin/switch.png";
import reset from "../../../assets/images/superadmin/reset.png";
import authn from "../../../assets/images/superadmin/Google_Authenticator.png";
import { faChevronDown, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactSearchAutocomplete } from "react-search-autocomplete";

import { CallApi } from '../../../Components/common/CommonFunctions.js';
import { handleRedirect } from './HandleRedirect.js';
import { toast } from 'react-toastify';
import { AddSession } from "../../../useAuth/SessionExtract.js";

const UserManage = ({ data, onBack }) => {

    const datafields = [
        { name: 'user_id', type: 'string' },
        { name: 'first_name', type: 'string' },
        { name: 'last_name', type: 'string' },
        { name: 'email_id', type: 'string' },
        { name: 'contact_number', type: 'string' },
        { name: 'role', type: 'string' },
        { name: 'department', type: 'string' },
        { name: 'cdm_access', type: 'string' },
        { name: 'edit_access', type: 'string' },
        { name: 'cclp_access', type: 'string' },
        { name: 'department_access', type: 'string' },
        { name: 'station_code', type: 'string' },
        { name: 'address', type: 'string' },
        { name: 'address2', type: 'string' },
        { name: 'city', type: 'string' },
        { name: 'country', type: 'string' },
        { name: 'postal_code', type: 'string' },
        { name: 'status', type: 'string' },
        { name: 'authorized', type: 'string' },
        { name: 'last_login', type: 'string' },
        { name: 'user_id_enc', type: 'string' },

    ]

    const columns = [
        {
            text: 'Activities',
            cellsrenderer: function () {
                return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + switc + '" class="user_switch" /><img src="' + trash + '" class="row_delete" /></div>';
            },
            width: '7%'
        },
        { text: 'First Name', filtertype: 'textbox', datafield: 'first_name', width: '8%', cellclassname: '', },
        { text: 'Last Name', filtertype: 'textbox', datafield: 'last_name', width: '8%', cellclassname: '', },
        { text: 'Email Id', filtertype: 'textbox', datafield: 'email_id', width: '18%', cellclassname: '', },
        { text: 'Role', filtertype: 'textbox', datafield: 'role', width: '10%', cellclassname: '', },
        {
            text: 'Last Login', datafield: 'last_login', width: '8%', filtertype: 'textbox',
            cellsrenderer: function (row, column, value) {
                if (row === 0) {
                    return `<div class="jqx-grid-cell-left-align" style="margin-top:13px;color: green !important;">${value}</div>`;
                }
                return `<div class="jqx-grid-cell-left-align" style="margin-top:13px;">${value}</div>`;
            }
        },
        // {
        //   text: 'Authorize',
        //   datafield: 'authorized',
        //   width: '6%',
        //   cellsrenderer: (row, column, val, rowData) => {
        //     // console.log("🚀 ~ UserSettings ~ val:", val)
        //     const isChecked = val === 1 ? 'checked' : '';
        //     const switchColor = val === 1 ? 'bg-success' : 'bg-danger';
        //     const id = rowData.id;
        //     return `
        //     <div style="margin-top:13px;">
        //       <div class="form-check form-switch">
        //         <input 
        //           class="form-check-input switchActiveInactive door_switchActiveInactive" 
        //           type="checkbox" 
        //           role="switch" 
        //           ${isChecked}
        //         />
        //       </div>
        //     </div>`;
        //   }
        // },
        { text: 'Station Code', filtertype: 'textbox', datafield: 'station_code', width: '8%' },
        { text: 'Address', filtertype: 'textbox', datafield: 'address', width: '8%' },
        { text: 'Address2', filtertype: 'textbox', datafield: 'address2', width: '8%' },
        { text: 'City', filtertype: 'textbox', datafield: 'city', width: '8%' },
        { text: 'Country', filtertype: 'textbox', datafield: 'country', width: '8%' },
        { text: 'Postal Code', filtertype: 'textbox', datafield: 'postal_code', width: '8%' },
        { text: 'Status', filtertype: 'textbox', datafield: 'status', width: '8%' },
        { text: 'Contact Number', filtertype: 'textbox', datafield: 'contact_number', width: '8%' },
        // { text: 'Department', filtertype: 'textbox', datafield: 'department', width: '17%', },
        // { text: 'CDM Access', filtertype: 'textbox', datafield: 'cdm_access', width: '10%' },
        // { text: 'CCLP Access', filtertype: 'textbox', datafield: 'cclp_access', width: '10%' },
        // { text: 'Edit Access', filtertype: 'textbox', datafield: 'edit_access', width: '10  %' },
        // { text: 'Department Access', filtertype: 'textbox', datafield: 'department_access', width: '14%' },

    ];


    const gridData = {
        Tab: 0,
        TabName: [], // {Active: [], Archives: []}
        Token: `SAToken`,
        EndPoint: `uld-setting/get-user-list?org_id=${data}`,
        Datafields: datafields,
        Columns: columns,
        nested: false,
        Options: {
            height: 1040,
            pageSize: 50,
            pagesizeoptions: ['50', '100', '200', '500'],
            selectionmode: 'checkbox',
        },
        colFunction: [
            { name: 'row_view', rowKey: 'org_id', },
            { name: 'row_edit', rowKey: 'org_id', },
            { name: 'row_delete', rowKey: 'org_id', },
            { name: 'user_manage', rowKey: 'org_id', },
            { name: 'user_switch', rowKey: 'org_id', },
            { name: 'user_permission', rowKey: 'org_id', },
        ]
    }

    const handleSwitch = (apiData) => {
        console.log('id', apiData);
        let endPoint = '';
        let payload = {};
        if (apiData.section == 'user_switch') {
            endPoint = 'switch-user'
            payload = { user_id_enc: apiData.data.user_id_enc, org_id: data }
        }
        CallApi({
            endPoint: endPoint,
            payload: payload,
            onSuccess: (data) => {
                console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    if (apiData.section == 'user_switch') {
                        sessionStorage.clear();

                        let addUrl = {}
                        if (innerData?.org_type === 'H') {
                            window.location.replace('/HandlerAdmin')
                            // sessionStorage.setItem('loc', '/HandlerAdmin');
                            addUrl = { ...innerData, loc: '/HandlerAdmin' }
                        } else if (innerData?.org_type === 'T') {
                            window.location.replace('/Trucker')
                            // sessionStorage.setItem('loc', '/Trucker');
                            addUrl = { ...innerData, loc: '/Trucker' }
                        } else {
                            window.location.replace('/Dashboard')
                            // sessionStorage.setItem('loc', '/Dashboard');
                            addUrl = { ...innerData, loc: '/Dashboard' }
                        }
                        AddSession('__A-', addUrl)
                    }
                        // const sendData = { ...innerData, loc: '/Dashboard', token_name: 'airlinetoken' }
                        // handleRedirect(sendData)
                    } else {
                        toast.error(data.data.response_msg);
                        console.log('resCode', resCode);
                    }
                    // setIsLoading(false)
                },
                onError: (msg) => toast.error(msg)
            });
    }

    const handleBack = () => { onBack() }

    return (
        <>
            <div className="row">
                <div className="col-md-6 d-flex gap-2">
                    <div className='text-start'><button type="button" className="btn" onClick={handleBack}>Back</button></div>
                    <div className='text-start'><button type="button" className="btn btn-primary addshipbtn"><FontAwesomeIcon icon={faPlus} /> Create Organization </button></div>
                </div>
                <div className="col-md-6">
                    <div className="d-flex gap-2 justify-content-end">
                        <div className='search'>
                            <div className="form-group has-search">
                                <ReactSearchAutocomplete
                                    autoFocus
                                    placeholder="Search"
                                />
                            </div>
                        </div>

                        <div>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                                    Organization Type <FontAwesomeIcon icon={faChevronDown} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                        <div>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                                    Creation Type <FontAwesomeIcon icon={faChevronDown} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                                    {/* <Dropdown.Item href="/ULDControl/NewCharter">New Charter</Dropdown.Item> */}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                        <div>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                                    Status <FontAwesomeIcon icon={faChevronDown} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                                    {/* <Dropdown.Item href="/ULDControl/NewCharter">New Charter</Dropdown.Item> */}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                    </div>

                </div>
            </div>
            <CommonGrid GD={gridData} onAction={handleSwitch} />
        </>
    )
}

export default UserManage;